import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-Headphones',
  standalone: true,
  templateUrl: '../../assets/Headphones.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamHeadphonesIcon {}
